import type { ApiResponse } from '~/api/types/Api'
import { ApiServiceBase } from '~/api/services/ApiServiceBase'

export default class PaymentService extends ApiServiceBase {
  async create(data: object): Promise<ApiResponse<object>> {
    return await this.call('/v1/payments', data)
  }
}
